import { downloadFile } from '../backend/helpers.js'

export default function openPdfTab(pdf) {
    downloadFile({ file: pdf?.data, fileName: 'download.pdf' })
}
